"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _helper = require("./helper");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _react2 = require("@linaria/react");
var _icon = require("@site/pattern-library-utils/icon");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable  max-statements */

const radius = 19;
const textWidth = 50;
const logoRadius = radius * 1.4;
const ActiveText = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "ActiveText",
  class: "pl-a1xkw5fr",
  vars: {
    "a1xkw5fr-1": [props => props.x, "px"],
    "a1xkw5fr-2": [props => props.isActive ? 1 : 0],
    "a1xkw5fr-3": [props => props.isActive ? 'visible' : 'hidden']
  }
});
const TextWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TextWrapper",
  class: "pl-tow3v3i"
});
const Text = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "Text",
  class: "pl-t1frvihj",
  vars: {
    "t1frvihj-1": [props => props.x.toFixed(2), "px"]
  }
});
const Wrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Wrapper",
  class: "pl-wnsmqaq",
  vars: {
    "wnsmqaq-0": [props => props.width, "px"]
  }
});
const Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pl-ct5di9s",
  vars: {
    "ct5di9s-0": [props => props.width, "px"],
    "ct5di9s-1": [props => props.height, "px"]
  }
});
const Svg = /*#__PURE__*/(0, _react2.styled)("svg")({
  name: "Svg",
  class: "pl-s11m1wz",
  vars: {
    "s11m1wz-0": [props => props.width, "px"],
    "s11m1wz-1": [props => props.height, "px"]
  }
});
const CircleWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CircleWrapper",
  class: "pl-ci3oank",
  vars: {
    "ci3oank-0": [props => 2 * props.radius, "px"],
    "ci3oank-3": [props => props.point.y - props.radius, "px"],
    "ci3oank-4": [props => props.point.x - props.radius, "px"],
    "ci3oank-6": [props => props.radius, "px"],
    "ci3oank-8": [props => props.point.y - props.height + props.radius, "px"]
  }
});
const CircleActiveElement = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CircleActiveElement",
  class: "pl-c34hkbh"
});
const GoDaddyLogo = /*#__PURE__*/(0, _react2.styled)(_icon.Icon)({
  name: "GoDaddyLogo",
  class: "pl-g1gkltmh"
});
const getMaxX = (width, defaultEndOffset) => width - defaultEndOffset || 1.5 * radius;
const getStepX = (step, maxX, steps) => step * (maxX / (steps.length - 1));
const getNewActiveStep = ({
  key,
  activeStep,
  steps
}) => {
  switch (key) {
    case 'ArrowUp':
    case 'ArrowRight':
      return Math.min(steps.length - 1, activeStep + 1);
    case 'ArrowLeft':
    case 'ArrowDown':
      return Math.max(1, activeStep - 1);
    default:
      return activeStep;
  }
};
class GraphSlider extends _react.PureComponent {
  constructor(props) {
    super(props);
    const {
      steps,
      width = 0,
      height,
      startStep,
      heightRate,
      defaultEndOffset
    } = props;
    this.pressed = false;
    const maxX = getMaxX(width, defaultEndOffset);
    const startX = getStepX(startStep, maxX, steps);
    this.circle = /*#__PURE__*/_react.default.createRef();
    this.container = /*#__PURE__*/_react.default.createRef();
    this.activeText = /*#__PURE__*/_react.default.createRef();
    this.removeAnimationTimeout = null;
    this.additionaUpdateStepTimeout = null;
    this.formula = (0, _helper.getFormula)({
      height,
      width,
      heightRate
    });
    this.state = {
      point: {
        x: startX,
        y: this.formula(startX)
      },
      activeStep: startStep
    };
    this.updateStep = this.updateStep.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleThumbKeyPress = this.handleThumbKeyPress.bind(this);
    this.setRemoveAnimationTimeout = this.setRemoveAnimationTimeout.bind(this);
    this.setAdditionalUpdateStepTimout = this.setAdditionalUpdateStepTimout.bind(this);
  }
  componentDidMount() {
    window.addEventListener('mouseup', this.handleMouseUp);
    window.addEventListener('mouseleave', this.handleMouseUp);
  }
  componentWillUnmount() {
    window.removeEventListener('mouseup', this.handleMouseUp);
    window.removeEventListener('mouseleave', this.handleMouseUp);
    clearTimeout(this.removeAnimationTimeout);
    clearTimeout(this.additionaUpdateStepTimeout);
  }
  componentDidUpdate(prevProps) {
    const {
      heightRate,
      height,
      width,
      defaultEndOffset,
      steps
    } = this.props;
    const {
      heightRate: prevHeightRate,
      height: prevHeight,
      width: prevWidth
    } = prevProps;
    if (heightRate !== prevHeightRate || height !== prevHeight || width !== prevWidth) {
      const {
        point,
        activeStep
      } = this.state;
      let {
        x: newX
      } = point;
      if (width !== prevWidth) {
        const maxX = getMaxX(width, defaultEndOffset);
        newX = getStepX(activeStep, maxX, steps);
      }
      this.formula = (0, _helper.getFormula)({
        height,
        width,
        heightRate
      });
      const newY = this.formula(newX);
      this.setState(state => ({
        ...state,
        point: {
          x: newX,
          y: newY
        }
      }), this.setAdditionalUpdateStepTimout);
    }
  }
  setRemoveAnimationTimeout() {
    if (this.removeAnimationTimeout) {
      clearTimeout(this.removeAnimationTimeout);
    }
    this.removeAnimationTimeout = setTimeout(() => {
      const {
        circle,
        activeText
      } = this;
      circle.current?.classList.toggle('animate', false);
      activeText.current?.classList.toggle('hidden', false);
    }, 500);
  }
  setAdditionalUpdateStepTimout() {
    if (this.additionaUpdateStepTimeout) {
      clearTimeout(this.additionaUpdateStepTimeout);
    }
    this.additionaUpdateStepTimeout = setTimeout(() => {
      this.updateStep(this.state.activeStep, false);
    }, 250);
  }
  updateStep(step, animate = true) {
    const {
      circle,
      activeText,
      formula
    } = this;
    const {
      steps,
      onChange,
      defaultEndOffset,
      width
    } = this.props;
    const {
      activeStep
    } = this.state;
    const maxX = getMaxX(width, defaultEndOffset);
    const newX = getStepX(step, maxX, steps);
    if (animate) {
      circle.current?.classList.toggle('animate', true);
      circle.current?.classList.toggle('move', false);
      activeText.current?.classList.toggle('hidden', false);
    }
    this.setState(state => ({
      ...state,
      activeStep: step,
      point: {
        x: newX,
        y: formula(newX)
      }
    }), this.setRemoveAnimationTimeout);
    if (step !== activeStep) {
      onChange(step);
    }
  }
  handleMouseDown() {
    this.pressed = true;
    this.circle.current?.classList.toggle('animate', false);
    this.circle.current?.classList.toggle('move', true);
    this.activeText.current?.classList.toggle('hidden', true);
  }
  handleMouseUp(event) {
    const {
      container,
      pressed
    } = this;
    const {
      width,
      steps,
      defaultEndOffset
    } = this.props;
    if (pressed && width) {
      const {
        left = 0
      } = container.current?.getBoundingClientRect() || {};
      const currentX = (event.pageX || event.changedTouches[0].pageX) - left;
      const maxX = getMaxX(width, defaultEndOffset);
      const x = Math.min(currentX, maxX);
      const step = maxX / (steps.length - 1);
      const n = x % step > step / 3 ? Math.ceil(x / step) : Math.floor(x / step);
      const newActiveStep = Math.max(n, 1);
      this.updateStep(newActiveStep);
    }
    this.pressed = false;
  }
  handleMouseMove(event) {
    const {
      pressed,
      container,
      formula
    } = this;
    const {
      width
    } = this.props;
    if (pressed) {
      const {
        left = 0
      } = container.current?.getBoundingClientRect() || {};
      const currentX = (event.pageX || event.changedTouches[0].pageX) - left;
      const x = Math.min(currentX, width);
      const y = formula(x);
      this.setState(state => ({
        ...state,
        point: {
          x,
          y
        }
      }));
    }
  }
  handleThumbKeyPress(event) {
    const {
      key
    } = event;
    const {
      steps
    } = this.props;
    const {
      activeStep
    } = this.state;
    const newActiveStep = getNewActiveStep({
      key,
      steps,
      activeStep
    });
    if (activeStep !== newActiveStep) {
      this.activeText.current?.classList.toggle('animate', true);
      this.updateStep(newActiveStep);
    }
  }
  render() {
    const {
      width,
      height,
      steps,
      defaultEndOffset
    } = this.props;
    const {
      activeStep,
      point
    } = this.state;
    const {
      activeText,
      circle,
      formula,
      container,
      handleMouseUp,
      handleMouseMove,
      handleMouseDown,
      handleThumbKeyPress
    } = this;
    const maxX = getMaxX(width, defaultEndOffset);
    return /*#__PURE__*/_react.default.createElement(Wrapper, {
      width: width,
      "data-cy": "savings-calculator-graph-slider"
    }, /*#__PURE__*/_react.default.createElement(Container, {
      ref: container,
      width: width,
      height: height,
      onMouseMove: handleMouseMove,
      onTouchMove: handleMouseMove
    }, /*#__PURE__*/_react.default.createElement(Svg, {
      width: width,
      height: height
    }, /*#__PURE__*/_react.default.createElement("linearGradient", {
      id: "gradient1"
    }, /*#__PURE__*/_react.default.createElement("stop", {
      id: "stop1",
      offset: "0%",
      stopColor: _intents.default.ux.figure.figureColor0
    }), /*#__PURE__*/_react.default.createElement("stop", {
      id: "stop2",
      offset: "100%",
      stopColor: _intents.default.ux.figure.figureColor0
    })), /*#__PURE__*/_react.default.createElement("linearGradient", {
      id: "gradient2",
      x1: "0",
      x2: "0",
      y1: "0",
      y2: "1",
      xlinkHref: "#gradient1"
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: (0, _helper.getPath)({
        height,
        width,
        formula
      }),
      fill: "url(#gradient2)"
    })), /*#__PURE__*/_react.default.createElement(CircleWrapper, {
      onKeyDown: handleThumbKeyPress,
      ref: circle,
      point: point,
      radius: radius,
      height: height,
      onMouseUp: handleMouseUp,
      onMouseDown: handleMouseDown,
      onTouchStart: handleMouseDown,
      onTouchEnd: handleMouseUp
    }, /*#__PURE__*/_react.default.createElement(CircleActiveElement, {
      role: "slider",
      "aria-valuemin": "1",
      "aria-valuemax": steps.length - 1,
      "aria-valuenow": activeStep,
      tabIndex: "0",
      "data-cy": "savings-calculator-graph-slider-active-element"
    }), /*#__PURE__*/_react.default.createElement(GoDaddyLogo, {
      name: "gd-the-go",
      height: logoRadius,
      width: logoRadius
    }))), /*#__PURE__*/_react.default.createElement(TextWrapper, null, /*#__PURE__*/_react.default.createElement(Text, {
      x: 0
    }, steps[0]), /*#__PURE__*/_react.default.createElement(ActiveText, {
      isActive: activeStep !== 0 && activeStep !== steps.length - 1,
      ref: activeText,
      x: point.x - textWidth / 2
    }, steps[activeStep]), /*#__PURE__*/_react.default.createElement(Text, {
      x: maxX - textWidth / 2
    }, steps[steps.length - 1])));
  }
}
var _default = exports.default = GraphSlider;
GraphSlider.propTypes = {
  width: _propTypes.default.number,
  height: _propTypes.default.number,
  steps: _propTypes.default.arrayOf(_propTypes.default.string),
  onChange: _propTypes.default.func,
  startStep: _propTypes.default.number,
  heightRate: _propTypes.default.number,
  defaultEndOffset: _propTypes.default.number
};